<template>
  <div class="chart-container">
    <div ref="main" class="bar-container"></div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue'
import { createColors } from '@/util/util'
const $t = Vue.prototype.$t
// 引入 ECharts 主模块
var echarts = require('echarts')
// 引入柱状图
// require('echarts/lib/chart/bar')
// // 引入饼图
// require('echarts/lib/chart/pie')
// // 引入提示框和标题组件
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/title')

function attendancePieOptions(data) {
  return {
    // title: {
    //   text: "员工出勤情况",
    // },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    color: ['#2FC25B', '#5D51DA', '#FFC800'],
    // 绘图网格
    grid: {
      // left: 0, //距离左边界
      // right: '10%',
      // bottom: '10%',
      top: 0,
      containLabel: true // 为true是可防止溢出
    },
    legend: {
      left: 'left',
      bottom: 20
    },
    series: [
      {
        type: 'pie',
        radius: '60%',
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
}

function servingBarOptions(data) {
  return {
    // title: {
    //   text: "员工司龄情况",
    // },
    color: ['#5D51DA'], // 柱状图颜色
    tooltip: {},
    xAxis: {
      data: ['0-1', '1-3', '3-5', '5-10', $t('1100')],
      name: `(${$t('1096')})`
    },
    yAxis: {
      name: `(${$t('1097')})`
    },
    series: [
      {
        type: 'bar',
        barWidth: 30, // 柱图宽度
        data,
        backgroundStyle: {
          color: 'rgba(204, 65, 65, 1)'
        }
      }
    ]
  }
}

function orgPieOptions(data) {
  return {
    // title: {
    //   text: "组织架构人员构成图",
    // },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} ({d}%)'
    },
    legend: {
      bottom: 40,
      left: 'left'
    },
    color: ['#FFC800', '#5D51DA', '#2FC25B', '#06D3C4', '#FF3976', '#914CE5', '#42B1CC', '#FF55AC'].concat(
      createColors(100)
    ),
    series: [
      {
        type: 'pie',
        radius: ['30%', '60%'],
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        data
      }
    ]
  }
}
function flowBarOptions(data) {
  return {
    legend: {
      bottom: 20,
      left: 'left'
    },
    tooltip: {},
    color: ['#5D51DA', '#2FC25B'],
    xAxis: {
      type: 'category',
      data: data.xAxisData
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: $t('1090'),
        type: 'bar',
        data: data.entryArr,
        barWidth: 30
      },
      {
        name: $t('1091'),
        type: 'bar',
        data: data.leaveArr,
        barWidth: 30
      }
    ]
  }
}
export default {
  name: 'chart',

  props: {
    type: {
      type: String,
      required: true
    },
    chartData: {
      type: [Array, Object],
      default: () => {
        return {}
      }
    }
  },
  methods: {
    initEcharts() {}
  },
  watch: {
    chartData(val) {
      let opt = {}
      if (this.type === 'attendancePie') {
        opt = attendancePieOptions(val)
      } else if (this.type === 'servingBar') {
        opt = servingBarOptions(val)
      } else if (this.type === 'orgPie') {
        opt = orgPieOptions(val)
      } else if (this.type === 'flowBar') {
        opt = flowBarOptions(val)
      }
      var myChart = echarts.init(this.$refs.main)
      myChart.setOption(opt, true)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-container {
  padding: 0 20px;
  // border: 1px solid #e4e7ed;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  // background: #fff;
  width: 100%;
  height: 100%;
  .bar-container {
    width: 100%;
    height: 100%;
  }
}
</style>
